export default function SurveyText({ text }) {
  return <p className="mb-1 leading-relaxed">{text}</p>;
}
